import React, { ReactElement } from 'react';

import { Icon } from '@iconify/react';

import router from '~/core/router';
import { settingsSidebar } from '~/core/sidebar';
import {
  BillingHistoryRoute,
  PersonalInformationRoute,
  SubscriptionRoute,
} from '~/modules/settings';
import { BILLING_HISTORY_ITEM_KEY } from '~/modules/settings/constants';
import { canAccessBillingHistory } from '~/modules/settings/views/BillingHistory/access';

router.addPrivateRoutes([
  PersonalInformationRoute,
  SubscriptionRoute,
  BillingHistoryRoute,
]);

settingsSidebar.addItems({
  a: [
    {
      key: 'personal_information',
      path: PersonalInformationRoute.path,
      getTitle: PersonalInformationRoute.getTitle,
      Icon: (props): ReactElement => (
        <Icon {...props} icon="material-symbols:person-outline" />
      ),
    },
    {
      key: 'subscription',
      path: SubscriptionRoute.path,
      getTitle: SubscriptionRoute.getTitle,
      Icon: (props): ReactElement => (
        <Icon {...props} icon="material-symbols:card-membership-outline" />
      ),
    },
    {
      key: BILLING_HISTORY_ITEM_KEY,
      path: BillingHistoryRoute.path,
      getTitle: BillingHistoryRoute.getTitle,
      checkAvailability: canAccessBillingHistory,
      Icon: (props): ReactElement => (
        <Icon {...props} icon="material-symbols:receipt-long-outline" />
      ),
    },
  ],
});
